import { StyledParagraph } from 'elements/Paragraph/styled';

const StyledSubtitle = StyledParagraph.extend`
  &:not(:empty) {
    margin-top: 8px;
    margin-bottom: 0;
  }
`;

export default StyledSubtitle;



// WEBPACK FOOTER //
// ./src/elements/Card/components/Content/styled/StyledSubtitle.js